import { render } from "./index.vue?vue&type=template&id=d6d7d5a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d6d7d5a4&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d7d5a4"]])

export default __exports__